import './App.css';
import { BrowserRouter as Routers, Route, Routes } from "react-router-dom";
import FirstPage from "./FirstPage/firstpage";
import SecondPage from "./SecondPage/secondpage";
import ThirdPage from "./ThirdPage/thirdpage";
import FourthPage from "./FourthPage/fourthpage";

function App() {
  return (
    <div>
      <Routers>
        <Routes>
          <Route path="/" element={<FirstPage />} />
          <Route path="/secondPage" element={<SecondPage />} />
          <Route path="/thirdPage" element={<ThirdPage />} />
          <Route path="/fourthPage" element={<FourthPage />} />

        </Routes>
      </Routers>
    </div>
  );
}

export default App;
